import { createSlice } from "@reduxjs/toolkit";

const paymentSlice = createSlice({
    name: "payment",
    initialState: {
        isLoading: false,
        isLoadingFile: false,
        isTextFileLoading: false,
        departmentList: [],
        roleList: [],
        paymentTypeList: [],
        employmentTypeList: [],
        workInLocationList: [],
        employeeList: [],
        employeeListCount: 0,
        payrollPeriod: {},
        totalEmployeeTab: {},
        incompleteList: [],
        periodOptions: [],
        newEmployeeList: [],
        resignList: [],
        employeeIncomeDeduction: {},
        employeeIncomeDeductionDefalut: {},
        employmentIncomeDeduction: {},
        countTxnPaymentByStatus: [],
        employmentIncome: [],
        employmentDeduct: [],
        employeeGroupCalculation: []
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setIsLoadingFile(state, action) {
            state.isLoadingFile = action.payload;
        },
        setIsTextFileLoading(state, action) {
            state.isTextFileLoading = action.payload;
        },
        setDepartmentList(state, action) {
            state.departmentList = action.payload;
        },
        setRoleList(state, action) {
            state.roleList = action.payload
        },
        setPaymentTypeList(state, action) {
            state.paymentTypeList = action.payload
        },
        setEmploymentTypeList(state, action) {
            state.employmentTypeList = action.payload
        },
        setWorkInLocationList(state, action) {
            state.workInLocationList = action.payload
        },
        setEmployeeList(state, action) {
            state.employeeList = action.payload
        },
        setEmployeeListCount(state, action) {
            state.employeeListCount = action.payload
        },
        setPayrollPeriod(state, action) {
            state.payrollPeriod = action.payload
        },
        setPeriodOptions(state, action) {
            state.periodOptions = action.payload
        },
        setTotalEmployeeTab(state, action) {
            state.totalEmployeeTab = action.payload
        },
        setIncompleteList(state, action) {
            state.incompleteList = action.payload
        },
        setNewEmployeeList(state, action) {
            state.newEmployeeList = action.payload
        },
        setResignList(state, action) {
            state.resignList = action.payload
        },
        setEmployeeIncomeDeduction(state, action) {
            state.employeeIncomeDeduction = action.payload
        },
        setEmployeeIncomeDeductionDefalut(state, action) {
            state.employeeIncomeDeductionDefalut = action.payload
        },
        setEmploymentIncomeDeduction(state, action) {
            state.employmentIncomeDeduction = action.payload
        },
        setCountTxnPaymentStatus(state, action) {
            state.countTxnPaymentByStatus = action.payload
        },

        setEmploymentIncome(state, action) {
            state.employmentIncome = action.payload
        },

        setEmploymentDeduct(state, action) {
            state.employmentDeduct = action.payload
        },
        setEmployeeGroupCalculation(state, action) {
            state.employeeGroupCalculation = action.payload
        },
        updateEmployeeGroupCalculation(state, action) {
            const { txnPaymentId, incomeListId, deductionListId } = action.payload;
            const item = state.employeeGroupCalculation.find(
                o => o.id === txnPaymentId
            );

            if (item) {
                item.income = incomeListId;
                item.deduction = deductionListId;
                item.editingStatus = item.editingStatus || "Y";
            }
        }


    }

})
export const {
    setDepartmentList,
    setRoleList,
    setPaymentTypeList,
    setEmploymentTypeList,
    setIsLoading,
    setWorkInLocationList,
    setIsLoadingFile,
    setEmployeeList,
    setEmployeeListCount,
    setPayrollPeriod,
    setPeriodOptions,
    setTotalEmployeeTab,
    setIncompleteList,
    setNewEmployeeList,
    setResignList,
    setEmployeeIncomeDeduction,
    setEmployeeIncomeDeductionDefalut,
    setEmploymentIncomeDeduction,
    setCountTxnPaymentStatus,
    setEmploymentIncome,
    setEmploymentDeduct,
    setIsTextFileLoading,
    setEmployeeGroupCalculation,
    updateEmployeeGroupCalculation
} = paymentSlice.actions

export default paymentSlice.reducer